import { WebshopBackgroudGradient } from '@shared/components/Images';
import clsx from 'clsx';
import { FC, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Cookies } from '../components/cookies/cookies';
import { Footer } from '../components/footer/footer';
import { Navbar } from '../components/navbar/navbar';
import { RouterPathes } from '../constants/router-paths';

const CHECKOUT_PATHS = new Set([RouterPathes.offerCheckout, RouterPathes.checkoutSuccess]);

export const AppLayout: FC = () => {
  const [showBanner, setShowBanner] = useState(true);
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isOfferCheckout = CHECKOUT_PATHS.has(location.pathname as RouterPathes);

  return (
    <main
      className={clsx(
        'bg-background flex w-full flex-col bg-[#1b1f54] bg-center',
        isMobileMenuOpen ? 'h-screen overflow-hidden' : 'min-h-screen',
      )}
    >
      {isOfferCheckout && <WebshopBackgroudGradient className="absolute" />}
      <Navbar isMobileMenuOpen={isMobileMenuOpen} setMobileMenuOpen={setMobileMenuOpen} />
      <Cookies
        showBanner={showBanner}
        setShowBanner={setShowBanner}
      />
      <main className="flex min-h-[640px] flex-1">
        <Outlet />
      </main>
      <Footer setShowBanner={setShowBanner} />
    </main>
  );
};
